import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

@Component({
  selector: 'app-sender-information',
  templateUrl: './sender-information.component.html',
  styleUrls: ['./sender-information.component.scss'],
})
export class SenderInformationComponent {
  senderInfoForm: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  formControls: any;
  response: any;
  result: any = {
    isResult: false,
    successfull: [],
  };
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    public dialogRef: MatDialogRef<SenderInformationComponent>,
    public fb: FormBuilder,
    private shippingService: ShippingService,
    private validationMessagesService: ValidationMessagesService,
    public toast: ToastrService
  ) {
    this.formControls = Object.keys(this.props.item.SenderInformation);
    this.initializeForm();
  }
  initializeForm() {
    this.formControls.forEach((f: any) => {
      if (f == 'selectedDeliveryPartner') {
        let partnerIds = this.props.item.Shipments.filter(
          (f: any, i: number, arr: any) =>
            arr.findIndex(
              (ff: any) => ff.DeliveryPartner == f.DeliveryPartner
            ) == i
        ).map((m: any) => m.DeliveryPartner);
        this.senderInfoForm.addControl(
          f,
          new FormControl(
            this.props.deliveryPartners
              .filter((f: any) => partnerIds.includes(f.id))
              .map((m: any) => m.name)
              .toString()
          )
        );
      } else {
        this.senderInfoForm.addControl(
          f,
          new FormControl(
            f == 'PickupInstruction'
              ? this.props.item.SenderInformation[f].NotificationEmail
              : this.props.item.SenderInformation[f]
          )
        );
      }
    });
  }
  formSubmit() {
    if (this.senderInfoForm.valid) {
      this.props.item.SenderInformation = this.senderInfoForm.value;
      // adding encodeURI for specific fileds in receiver information
      this.props.item.Shipments.forEach((shipment: any) => {
        const receiverInfo = shipment.Shipment.ReceiverInformation;
        ['Address1', 'Address2', 'StreetName', 'Geolocation', 'FirstName', 'LastName', 'Delivery_instruction', 'Name', 'City'].forEach((field) => {
          // Check if the field exists and is a string before encoding
          if (receiverInfo && receiverInfo[field] && typeof receiverInfo[field] == 'string') {
            receiverInfo[field] = encodeURIComponent(receiverInfo[field]);
          }
        });
        //encode notes field
        if (shipment?.Shipment?.Notes && typeof shipment?.Shipment?.Notes == 'string'){
          shipment.Shipment.Notes = encodeURIComponent(shipment?.Shipment?.Notes)
        }
      });
      this.isLoading = true;
      this.shippingService.check_rate(this.props.item).pipe(first()).subscribe(
        (res) => {
          if (res.body.success) {
            this.response = res;
            this.result.isResult = true;
            this.result.successfull = res.body.data.filter(
              (f: any) => f.Success
            );
            this.isLoading = false;
          } else {
            this.toast.error(res.body.message[0]);
            this.isLoading = false;
          }
        },
        (err) => {
          this.toast.error(err.message);
          this.isLoading = false;
        }
      );
    } else {
      this.validationMessagesService.validateAllFormFields(this.senderInfoForm);
    }
  }
  continue() {
    this.dialogRef.close({
      payload: this.props.item,
      response: this.response?.body,
    });
  }
}
